import { Pipe, PipeTransform } from '@angular/core';
import { PrintInBasket, ShoppingCartState } from '../../actions/standalone';
import { select, Store } from '@ngrx/store';
import {
  selectCalcPrintsInPackage,
  selectPackagesInBasket,
  selectPhotoGroups,
  selectPhotosList,
  selectPrintPrices,
  selectPrintsInBasket,
} from '../../actions/selector';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { calcPriceOnePositionPrintsInBasketWithoutFirstPrint } from '../../calc-price-all-prints-in-basket/calc-price-all-prints-in-basket';

@Pipe({
    name: 'printPrice',
    standalone: false
})
export class PrintPricePipe implements PipeTransform {
  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  transform(actualPrintInBasket: PrintInBasket) {
    return combineLatest([
      this.store.pipe(select(selectPrintPrices)),
      this.store.pipe(select(selectPhotoGroups)),
      this.store.pipe(select(selectPhotosList)),
      this.store.pipe(select(selectPrintsInBasket)),
      this.store.pipe(select(selectPackagesInBasket)),
      this.store.pipe(select(selectCalcPrintsInPackage)),
    ]).pipe(
      map(
        ([
          printPrices,
          photoGroups,
          photoGroupList,
          printsInBasket,
          packagesInBasket,
          calcPrintsInPackage,
        ]) => {
          return calcPriceOnePositionPrintsInBasketWithoutFirstPrint(
            actualPrintInBasket,
            printsInBasket,
            printPrices,
            photoGroupList,
            photoGroups,
            calcPrintsInPackage,
            packagesInBasket
          );
        }
      )
    );
  }
}
